import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ApplicationFeesService } from '@tv3/store/application-fees/application-fees.service'

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [ApplicationFeesService],
})
export class ApplicationFeesModule {}
